var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98316 24C10.1859 24.0033 10.3848 23.9449 10.5536 23.8326C10.7223 23.7202 10.853 23.5593 10.9282 23.371L14.7692 13.77L24.3712 9.92899C24.5569 9.85479 24.7161 9.72661 24.8282 9.561C24.9403 9.3954 25.0002 9.19998 25.0002 8.99999L25.0002 8.98398C24.997 8.78145 24.9324 8.58466 24.8149 8.41966C24.6974 8.25466 24.5325 8.12924 24.3422 8.05999L2.34216 0.0599861C2.16319 -0.00550275 1.96922 -0.0184823 1.78312 0.0225715C1.59701 0.0636234 1.42652 0.157003 1.2917 0.291712C1.15689 0.426418 1.06338 0.596844 1.02218 0.782917C0.980981 0.968988 0.993812 1.16296 1.05916 1.34199L9.05916 23.342C9.12859 23.5324 9.2542 23.6973 9.41937 23.8148C9.58454 23.9323 9.78149 23.9969 9.98416 24L9.98316 24Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.adaa0a2b0ac0bd82a9ddd6ba4f8251b7.svg";
export { ForwardRef as ReactComponent };